var isUndefined = function (value) {
  return value === undefined;
};

export default isUndefined;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/is-undefined.js
// module id = 88
// module chunks = 0